import React, { RefObject, useEffect, useState } from "react"
import { HiChevronDoubleDown, HiChevronDoubleUp } from "react-icons/hi"

type ScrollTopButtonProps = {
   containerRef: RefObject<HTMLDivElement | null>
   direction?: 'top' | 'bottom'
}

// Threshold where the button is visible
const threshold = 200

const ScrollToButton: React.FC<ScrollTopButtonProps> = ({ containerRef, direction = 'top' }) => {
   const [visible, setVisible] = useState(false)

   // Toggle visibility based on scroll position
   useEffect(() => {
      const container = containerRef?.current
      if (!container) return

      const handleScroll = () => {
         setVisible(container.scrollTop > threshold)
      }

      container.addEventListener('scroll', handleScroll)

      return () => container.removeEventListener('scroll', handleScroll)
   }, [containerRef])

   const scrollTo = () => {
      containerRef.current?.scrollTo({
         top: 0,
         behavior: 'smooth'
      })
   }

   return (
      visible === true
         ? <button
            onClick={scrollTo}
            className="fixed flex justify-center active:bg-border items-center bottom-[78px] right-3.75 z-50 w-12.5 h-12.5 bg-white opacity-70 rounded-full shadow-md transition"
         >
            {direction === 'top'
               ? <HiChevronDoubleUp size={20} strokeWidth={"0.25"} />
               : <HiChevronDoubleDown size={20} strokeWidth={"0.25"} />}
         </button>
         : null
   )
}

export default ScrollToButton